import { formatGameTime } from '../helpers/formatters';
import { ee } from '../../eventEmitter';

export default class GameTimerView {
    #el;

    constructor(elementId) {
        this.#el = document.getElementById(elementId);
        this.addListeners();
    }

    addListeners() {
        this.#el.addEventListener('click', () => {
            ee.emit('timerClick');
        });
    }

    update(time) {
        this.#el.innerHTML = formatGameTime(time);
    }
}
